import React, {useEffect, useState} from "react";
import {useAppDispatch, useAppSelector} from "../../utils/Hooks";
import { useNavigate } from "react-router-dom";
import {LoggedInView} from "../common/LoggedInView";
import Breadcrumbs from "../common/Breadcrumbs";
import ElogInput from "../common/form/ElogInput";
import {BreadcrumbLink} from "../../models/BreadcrumbLink";
import {Link, useParams} from "react-router-dom";
import {
    createCategoryType,
    resetUpdateCategoryTypeStatus,
    updateCategoryType
} from "../../store/reducers/CategoryTypesSlice";
import {RequestStatus} from "../../utils/Enums";
import {FormikProvider, useFormik, Form} from "formik";
import {createSMSSender} from "../../store/reducers/SMSSendersSlice";

interface NewCategoryTypeScreenProps {
}

export interface NewCategoryTypeFormProps {
    name: string;
    order: number;
}

export const NewCategoryTypeScreen: React.FC<NewCategoryTypeScreenProps> = () => {

    const dispatch = useAppDispatch();
    const navigate = useNavigate();

    const categoryTypesState = useAppSelector(state => state.categoryTypes);
    const requestStatus: RequestStatus = categoryTypesState.createCategoryTypeStatus;

    const breadcrumbLinks: BreadcrumbLink[] = [
        {text: 'Grupi tüübid', url: '/category-types'},
        {text: 'Lisa uus grupi tüüp', url: '/category-types/new'},
    ];

    useEffect(() => {
        if ( requestStatus === RequestStatus.Success ) {
            dispatch(resetUpdateCategoryTypeStatus());
            navigate(breadcrumbLinks[0].url);
        }

    }, [requestStatus]);

    // @ts-ignore
    const formik = useFormik({
        initialValues: {
        },
        onSubmit: (values: any) => {
            dispatch(createCategoryType(values));
        },
        enableReinitialize: true
    });

    const {values, setFieldValue, handleSubmit} = formik;

    return (
        <LoggedInView fullWidth={false}>
            <Breadcrumbs links={breadcrumbLinks}/>
            <FormikProvider value={formik}>
                <Form onSubmit={handleSubmit}>
                    <div className="form">
                        <h2><span>Grupi tüübi andmed</span></h2>
                        <table className="form">
                            <tbody>
                            <ElogInput label="Nimi" name="name" mandatory={true}/>
                            <ElogInput label="Järjekorra number" name="order" mandatory={false}/>
                            </tbody>
                        </table>
                    </div>
                    <div className="action clear">
                        <p>
                            <button type="submit">
                                <span><strong>Sisesta</strong></span>
                            </button>
                            <Link to="/category-types">Tühista</Link>
                        </p>
                    </div>
                </Form>
            </FormikProvider>
        </LoggedInView>
    )

}